import { useEffect } from 'react'

export function useIOSScrollLock(needLock: boolean) {
  useEffect(() => {
    if (!needLock) {
      return
    }
    let startY = 0

    const onTouchStart = (e: TouchEvent) => {
      startY = e.touches[0].clientY
    }

    const onTouchMove = (e: TouchEvent) => {
      const currentY = e.touches[0].clientY
      if (window.scrollY === 0 && currentY > startY) {
        e.preventDefault()
      }
    }

    document.addEventListener('touchstart', onTouchStart, { passive: false })
    document.addEventListener('touchmove', onTouchMove, { passive: false })

    return () => {
      document.removeEventListener('touchstart', onTouchStart)
      document.removeEventListener('touchmove', onTouchMove)
    }
  }, [needLock])
}
